import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ToastModal from "views/components/ToastModal";
import { riskCategoryTableColumns } from "assets/properties/properties";
import { riskCategoryScoreTableColumns } from "assets/properties/properties";
import axios from "axios";
import ConfirmationModal from "views/components/ConfirmationModal";
const RiskCategoryScoreMaster = () => {
  const navigate = useNavigate();
  const [rawData, setRawData] = useState([]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [deleteSchemeId, setDeleteSchemeId] = useState("");
  // submit create function
  const handleCreateRiskCategory = () => {
    navigate(`/coreservice/riskCategoryScore-create`);
  };
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  // get api calling
  useEffect(() => {
    GetData();
  }, []);

  const GetData = async (data) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.RISK_CATEGORY_SCORE_FIND_ALL,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setRawData(result?.data);
      parseIndicatorData(result?.data);
    }
  };

  // parseindicatordata function
  const parseIndicatorData = (data) => {
    let reportData = [];

    data.forEach((role) => {
      let row = {
        riskCategory: role?.riskCategory,
        minAuditedLtv: role?.minAuditLtvScore,
        maxAuditedLtv: role?.maxAuditLtvScore,
        action: getIcons(role?.id),
        viewCode: role?.id,
      };

      reportData.push(row);
    });

    setSelectedTableData(reportData);
  };

  // icons function
  const getIcons = (id) => {
    return (
      <>
        <IconButton
          aria-label="Edit id"
          onClick={(e) => {
            e.stopPropagation();
            onClickUpdateData(id);
          }}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          aria-label="Delete Scheme"
          onClick={(e) => {
            e.stopPropagation();
            onClickDeleteData(id)
          }}
        >
          <DeleteIcon />
        </IconButton>
      </>
    );
  };
  // update function
  const onClickUpdateData = (id) => {
    navigate(`/coreservice/riskCategoryScore-create/` + id);
  };
  const onClickDeleteData = (id) => {
    setConfirmationModalHeader("Loan Scheme");
    setConfirmationModalMsg("Are you sure you want to delete this entry");
    setDeleteSchemeId(id);
    setConfirmationModal(true);
  };

  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setDeleteSchemeId("");
  };
  const handlePositiveResponse = async () => {
    const schemeId = deleteSchemeId;
    handleNegativeResponse();
    setCallInProgress(true);
    // Call API to delete User
    const URL =
      endpoint.BASE_URL_STAGING + "/" + endpoint.RISK_CATEGORY_SCORE_DELETE;
    const res = await axios.delete(URL + schemeId, {
      headers: {
        Authorization: "Bearer " + authToken,
      },
    });
    setCallInProgress(false);

    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      toastUpdate("Success", "Delete Risk Category is successfull", true);
      GetData();
    }
  };
  // serach function
  const onSearchChange = (event) => {
    const filteredData = rawData.filter((row) => {
      const val = event.target.value;
      return (
        row?.riskCategory?.toLowerCase()?.includes(val?.toLowerCase())
      );
    });
    parseIndicatorData(filteredData);
  };

  // view function
  const onClickViewData = (code, type) => {
    navigate(`/coreservice/riskCategoryScore-createView/` + code);
  };
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <SubHeader
          label="Risk Category Score Master"
          button1="Create"
          button1click={handleCreateRiskCategory}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <ColumnGroupingTable
          columns={riskCategoryScoreTableColumns}
          rows={selectedTableData}
          onClickViewData={onClickViewData}
          clickable
        />
      </GridItem>
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
      />
    </GridContainer>
  );
};

export default RiskCategoryScoreMaster;
